/* -------------------------------------------------------------------------
   Michael Vardani — collection page behaviour.
   Two custom elements:
     <mv-filters>  native Shopify facet form, submits on change
     <mv-tabrail>  scrolls the active category tab into view on mobile
   Both are idempotent and safe to re-register when the theme editor
   re-renders a section.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (!window.customElements) return;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ filters --- */

  if (!customElements.get('mv-filters')) {
    customElements.define(
      'mv-filters',
      class MvFilters extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.details = this.querySelector('details');
          this.onChange = this.onChange.bind(this);
          this.onDocClick = this.onDocClick.bind(this);
          this.onKey = this.onKey.bind(this);
          if (this.form) this.form.addEventListener('change', this.onChange);
          document.addEventListener('click', this.onDocClick);
          this.addEventListener('keydown', this.onKey);
        }

        disconnectedCallback() {
          if (this.form) this.form.removeEventListener('change', this.onChange);
          document.removeEventListener('click', this.onDocClick);
          this.removeEventListener('keydown', this.onKey);
        }

        onChange() {
          if (!this.form || this.dataset.autoSubmit === 'false') return;
          this.form.submit();
        }

        onDocClick(event) {
          if (!this.details || !this.details.open) return;
          if (this.contains(event.target)) return;
          this.details.open = false;
        }

        onKey(event) {
          if (event.key !== 'Escape' || !this.details) return;
          this.details.open = false;
          var summary = this.querySelector('summary');
          if (summary) summary.focus();
        }
      }
    );
  }

  /* ------------------------------------------------------------ tabrail --- */

  if (!customElements.get('mv-tabrail')) {
    customElements.define(
      'mv-tabrail',
      class MvTabrail extends HTMLElement {
        connectedCallback() {
          var rail = this.querySelector('[data-mv-tabrail-track]') || this;
          var active = this.querySelector('[aria-current="page"]');
          if (!active || !rail.scrollWidth || rail.scrollWidth <= rail.clientWidth) return;
          var target = active.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2;
          if (rail.scrollTo) {
            rail.scrollTo({ left: Math.max(0, target), behavior: REDUCED ? 'auto' : 'smooth' });
          } else {
            rail.scrollLeft = Math.max(0, target);
          }
        }
      }
    );
  }
})();
